import { atomWithStorage } from 'jotai/utils';
import { atom } from 'jotai'

export const statusColors = {
  'On Track': 'seagreen',
  'Finished': 'firebrick',
  'Driver Change': 'goldenrod',
  'In Pit': 'darkorange',
  'Queued': 'cadetblue',
  'Off Track': 'grey'
} as const;

export const statusOrder = {
  'On Track': 1,
  'Driver Change': 2,
  'In Pit': 3,
  'Queued': 4,
  'Finished': 5,
  'Off Track': 6
} as const;

export interface StatusUpdate {
  CarNumber: number;
  Status: string;
  Timestamp: string;
}

export interface UIDUpdate {
  CarNumber: number;
  UID: string;
}

export interface LapUpdate {
  CarNumber: number;
  HalfLap: number;
  EndLap: number;
}

export default interface Car {
  CarNumber: number,
  UID: string,
  Transponder?: string | null,
  TransponderAssignedAt?: string | null,
  Institution: string,
  TeamName?: string | null,
  VehicleClass?: 'H' | 'E' | null,
  StaticOnly?: boolean,
  AutocrossTime?: string | number | null,
  AccelerationTime?: string | number | null,
  LastReception: string,
  Status: string,
  StartEnergy: number,
  EnergyAccum: number,
  StartDistance: number,
  DistanceAccum: number,
  LapStart: number,
  LapHalf: number,
  LapEnd: number,
  StartTime: string,
  EndTime: string
};

export const carAtom = atom<Car | null>(null);

export const allCarsAtom = atomWithStorage<Car[] | null>('allCars', null);
